var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-stats-panel"},[_c('div',{staticClass:"main-stats-icon"},[_c(_vm.iconComponent,{tag:"component"})],1),_c('div',{staticClass:"main-stats-value"},[_vm._v(" "+_vm._s(_vm.count)+" ")]),_c('div',{staticClass:"main-stats-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }